import type { IconData } from '@stacksjs/iconify-core'

export const playListFolder: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M42.994 20a211 211 0 0 0-.108-5.62c-.104-3.12-2.705-5.516-5.828-5.516H22.833a4 4 0 0 1-3.03-1.389L17.86 5.221c-1.208-1.401-3-2.18-4.844-2.033c-2.936.233-5.012.549-6.429.835c-1.705.344-2.858 1.695-3.04 3.426C3.287 9.908 3 14.344 3 21.919s.288 12.011.547 14.47c.182 1.73 1.335 3.082 3.04 3.426c2.236.452 6.11.976 12.413 1.136\"/><path d=\"M31.5 24.501c0-1.5 1.37-2.647 2.678-2.486c6.876.85 9.67 6.61 10.786 10.557c.235.83-.735 1.21-1.245.533c-2.123-2.818-4.468-4.141-6.441-4.736c-.457-.138-.892.242-.892.746L36 39a6 6 0 1 1-4.5-5.811z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default playListFolder
